var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"size":_vm.size,"type":_vm.type,"icon":_vm.icon,"disabled":_vm.disabled,"plain":"","loading":_vm.loading},on:{"click":_vm.handleClick}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }